import React from "react";
import { Sidebar } from "react-admin";

const UZHAdminSidebar = props => <Sidebar {...props} />;

export default UZHAdminSidebar;
